import * as React from "react";
import { createFieldIds } from "../../utils/utils/create-field-ids.js";
const createInitialState = (lineItems) => {
  return lineItems.map((_, index) => {
    const fieldIds = createFieldIds(`${index}`);
    return {
      [fieldIds.checkbox]: {
        name: fieldIds.checkbox,
        value: "",
        isValid: false,
        isTouched: false
      }
    };
  }).reduce((acc, item) => ({ ...acc, ...item }), {});
};
const useReturnFormState = (lineItems = []) => {
  const initialState = React.useMemo(() => createInitialState(lineItems), [lineItems]);
  const [formState, setFormState] = React.useState(initialState);
  return { formState, setFormState };
};
export {
  useReturnFormState
};
//# sourceMappingURL=use-return-form-state.js.map
